module.exports = __webpack_public_path__ + "img/turkey.b0fec962.png";